export default __webpack_public_path__ + "static/media/CalendarIcon.3914af5d.svg";